import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, forwardRef, Inject, PLATFORM_ID, Renderer2, ViewChild, ViewEncapsulation, OnDestroy } from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CloseOnContainerBlurDirective } from '@techmore/share';
import { EventReplayer } from 'preboot';
import { Subscription } from 'rxjs';
import { fadeInOutAnimation } from 'src/app/share/entity/animation';
import { BackStageTemplateService } from 'src/app/share/service/back-stage-template.service';
import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import { AbstractTemplate, ABSTRACT_TEMPLATE_TOKEN } from '../../../abstract-template';
import { TemplateService } from '../../../service/template.service';

@Component({
  selector: 'app-template-040',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss'],
  providers: [
    {provide: ABSTRACT_TEMPLATE_TOKEN,  useExisting: forwardRef(() => IndexComponent), multi: false}
  ],
  animations: [fadeInOutAnimation],
  encapsulation: ViewEncapsulation.None
})
export class IndexComponent extends AbstractTemplate implements OnDestroy {
  @ViewChild('mainMenuCcb', {static: false}) set mainMenuCcb(ccb: CloseOnContainerBlurDirective) {
    ccb.closeContainer = (toggler?: HTMLElement, container?: HTMLElement) => {
      if (this.isBrowser) {
        $(container).collapse('hide');
      }
    };
    ccb.listenOnOpen = (cb: () => void) => {
      if (this.isBrowser) {
        $(ccb.tmCloseOnContainerBlur).on('shown.bs.collapse', (e) => {
          e.stopPropagation();
          cb();
        });
      }
    };
    ccb.listenOnClose = (cb: () => void) => {
      if (this.isBrowser) {
        $(ccb.tmCloseOnContainerBlur).on('hidden.bs.collapse', (e) => {
          e.stopPropagation();
          cb();
        });
      }
    };
  }

  menuAutoColseSubc: Subscription;
  @ViewChild('menuToggler', {static: false}) set menuToggler(elRef: ElementRef) {
    if (elRef) {
      if (this.menuAutoColseSubc) {
        this.menuAutoColseSubc.unsubscribe();
      }

      this.menuAutoColseSubc = this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
          return;
        }
        const el = elRef.nativeElement as HTMLElement;
        if (!el.classList.contains('collapsed')) {
          el.click();
        }
      });
    }
  }

  mbMenuAutoColseSubc: Subscription;
  @ViewChild('mbMenuToggler', {static: false}) set mbMenuToggler(elRef: ElementRef) {
    if (elRef) {
      if (this.mbMenuAutoColseSubc) {
        this.mbMenuAutoColseSubc.unsubscribe();
      }

      this.mbMenuAutoColseSubc = this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
          return;
        }
        const el = elRef.nativeElement as HTMLElement;
        if (!el.classList.contains('collapsed')) {
          el.click();
        }
      });
    }
  }

  constructor(
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    protected templateService: TemplateService,
    protected router: Router,
    protected route: ActivatedRoute,
    @Inject(DOCUMENT) protected document: any,
    protected translate: TranslateService,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected render: Renderer2,
    protected el: ElementRef,
    protected serverConfigService: ServerConfigService,
    protected backStageTemplateService: BackStageTemplateService,
    protected replayer: EventReplayer,
  ) {
    super(generatorEnv, templateService, router, route, document, translate, platformId, render, el, serverConfigService, backStageTemplateService, replayer);
  }

  ngOnDestroy(): void {
    if (this.menuAutoColseSubc) {
      this.menuAutoColseSubc.unsubscribe();
      delete this.menuAutoColseSubc;
    }
    if (this.mbMenuAutoColseSubc) {
      this.mbMenuAutoColseSubc.unsubscribe();
      delete this.mbMenuAutoColseSubc;
    }
  }

  onClickMenuDiv(e: UIEvent, menuToggler: HTMLElement) {
    if (e.target === e.currentTarget) {
      menuToggler.click();
    }
  }
}
